import React from 'react'

import { capitalize } from '../utils'

const Breadcrumbs = ({ intent = '', long }) => {
    let parts = []
    if (intent.indexOf('/') !== -1) {
        parts = intent.split('/')
    } else {
        parts = intent.split('.')
    }
    const [contentType, intentName] = parts.slice(1)
    return (
        <nav className="breadcrumbs">
            {long && (
                <a
                    className="breadcrumbs__link"
                    href="/api-platform"
                    title="Intent Catalog"
                >
                    Intent&nbsp;Catalog
                </a>
            )}
            {long && <span className="breadcrumbs__sep"> / </span>}
            <a className="breadcrumbs__link" href="/api-platform/ai" title="AI">
                AI
            </a>
            <span className="breadcrumbs__sep"> / </span>
            <a
                className="breadcrumbs__link"
                href={`/api-platform/ai/${contentType}`}
                title={capitalize(contentType)}
            >
                {capitalize(contentType)}
            </a>
            <span className="breadcrumbs__sep"> / </span>
            <a
                className="breadcrumbs__link"
                href={`/api-platform/ai/${contentType}/${intentName}`}
                title={capitalize(intentName)}
            >
                {capitalize(intentName)}
            </a>
        </nav>
    )
}

export default Breadcrumbs



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Breadcrumbs.jsx